import axios from 'axios';

const BASE_URL = () => {
   let url = '';
   console.log('Environment ' + process.env.REACT_APP_ENV);
   if (process.env.REACT_APP_ENV === 'development') {
      url = 'https://stage-api.iaminharmony.com/v1';
   } else if (process.env.REACT_APP_ENV === 'staging') {
      url = 'https://stage-api.iaminharmony.com/v1';
   } else if (process.env.REACT_APP_ENV === 'production') {
      url = 'https://api.iaminharmony.com/v1';
   } else {
      url = 'https://stage-api.iaminharmony.com/v1';
   }

   return url;
};

const instance = axios.create({
   baseURL: BASE_URL(),
});

export default instance;

export const Stripkey = () => {
   if (process.env.REACT_APP_ENV === 'development') {
      return 'pk_test_51HPBhZLANpdVcV82gAFY8mqMveeopsPP7g0Rqdp4jPBA4bpQPxBpRP06uFrYhccOGGjrDcyDFOrwnNAOrTuysEzk00yRF8qdaA';
   } else if (process.env.REACT_APP_ENV === 'staging') {
      return 'pk_test_51HPBhZLANpdVcV82gAFY8mqMveeopsPP7g0Rqdp4jPBA4bpQPxBpRP06uFrYhccOGGjrDcyDFOrwnNAOrTuysEzk00yRF8qdaA';
   } else if (process.env.REACT_APP_ENV === 'production') {
      return 'pk_live_51HPBhZLANpdVcV82zhboXcMt8kfoJIm7t64MVdGvHnG2zJLslA9H9X1cIisxF0bwqRegapTcw0p6gYqkHjFoJb0w00RWqwdaye';
   } else {
      //undefined
      return 'pk_test_51HPBhZLANpdVcV82gAFY8mqMveeopsPP7g0Rqdp4jPBA4bpQPxBpRP06uFrYhccOGGjrDcyDFOrwnNAOrTuysEzk00yRF8qdaA';
   }
};

export const stripe_plan_id = (plan_id) => {
   let STRIPE_PLAN_YEARLY;
   let STRIPE_PLAN_MONTHLY;
   if (process.env.REACT_APP_ENV === 'development') {
      STRIPE_PLAN_YEARLY = "price_1HkNfuLANpdVcV82Ygn98t5J";
      STRIPE_PLAN_MONTHLY = "price_1HWLaILANpdVcV82vybhSoeA";
   } else if (process.env.REACT_APP_ENV === 'staging') {
      STRIPE_PLAN_YEARLY = "price_1HkNfuLANpdVcV82Ygn98t5J";
      STRIPE_PLAN_MONTHLY = "price_1HWLaILANpdVcV82vybhSoeA";
   } else if (process.env.REACT_APP_ENV === 'production') {
      STRIPE_PLAN_YEARLY = "price_1HjihqLANpdVcV823n3mMbrS"
      STRIPE_PLAN_MONTHLY = "price_1HjihyLANpdVcV82PmVvysx7"
   } else {
      STRIPE_PLAN_YEARLY = "price_1HkNfuLANpdVcV82Ygn98t5J";
      STRIPE_PLAN_MONTHLY = "price_1HWLaILANpdVcV82vybhSoeA";
   }
   let PLAN_ID;
   if (plan_id == STRIPE_PLAN_YEARLY) {
      PLAN_ID = "STRIPE_PLAN_YEARLY"
   } else if (plan_id == STRIPE_PLAN_MONTHLY) {
      PLAN_ID = "STRIPE_PLAN_MONTHLY"
   }
   return PLAN_ID
}